import React from 'react';
import { PropTypes } from 'prop-types';

const useSearchMode = ({
    isPublicationsSearch,
    searchTypeIndex,
    isAttendeeSearch,
    isMemberCompanySearch,
    eventCode,
    showFilters,
}) => {
    // hide filters for everything and publication seach
    if (showFilters === undefined) {
        showFilters = searchTypeIndex !== 'everything' && !isPublicationsSearch;
    }
    // Not a special stand-alon search page like attendee or publications
    const isPlainSearchMode = !isAttendeeSearch && !isMemberCompanySearch && !isPublicationsSearch;
    return { isMemberCompanySearch, isPublicationsSearch, isPlainSearchMode, showFilters, eventCode };
};

useSearchMode.propTypes = {
    eventCode: PropTypes.string,
    companyId: PropTypes.number,
    isPublicationsSearch: PropTypes.bool,
    searchTypeIndex: PropTypes.string,
};

export default useSearchMode;
